import { render, staticRenderFns } from "./PayingScbEasy.vue?vue&type=template&id=4f97cd5b"
import script from "./PayingScbEasy.vue?vue&type=script&lang=js"
export * from "./PayingScbEasy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports